import { render, staticRenderFns } from "./VehicleAd.vue?vue&type=template&id=58a216d0&scoped=true&"
import script from "./VehicleAd.vue?vue&type=script&lang=js&"
export * from "./VehicleAd.vue?vue&type=script&lang=js&"
import style0 from "./VehicleAd.vue?vue&type=style&index=0&id=58a216d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a216d0",
  null
  
)

export default component.exports